const ADSENSE_SCRIPT_ID = 'mainstage-adsense';
const ADSENSE_SCRIPT_URL =
  'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4048950503894834';

// Published AdSense Privacy & messaging messages and their revocation/opt-out
// links are delivered by the AdSense tag. Auto ads is managed in AdSense and
// remains off; this integration does not create or request any ad units.
// https://developers.google.com/funding-choices/fc-api-docs
export function initializePrivacyMessaging(): void {
  if (
    !import.meta.env.PROD ||
    !['mainstage.win', 'www.mainstage.win'].includes(window.location.hostname) ||
    /^\/privacy\/?$/.test(window.location.pathname) ||
    document.getElementById(ADSENSE_SCRIPT_ID)
  ) {
    return;
  }

  // Google requires the linked privacy policy to stay free of ad/CMP tags.
  // Links to /privacy force a document navigation so a previously loaded tag
  // cannot survive an SPA transition into that page.

  const script = document.createElement('script');
  script.id = ADSENSE_SCRIPT_ID;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = ADSENSE_SCRIPT_URL;
  document.head.appendChild(script);
}
